import { MessageType, RawAudioMessage, RawMessage } from "@/store/chats/types";

export const getIsRawMessageAudioType = (
  message: RawMessage,
): message is RawAudioMessage => message.messageType === MessageType.Audio;
